import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import isHotKey from 'is-hotkey';
import { MoreIcon, DeleteIcon, ArrowLeftIcon, ArrowRightIcon, ArrowBottomIcon, ArrowTopIcon, CloseIcon, SwitchIcon } from '../../../Icons';
import Button from '../../../Button';
import Menu from '../../../Menu';
import TinyPopover from '../../../TinyPopover';
import Database from '../../controllers/Database';
import ColumnTypes from '../../types/ColumnTypes';
import OrderTypes from '../../types/OrderTypes';
import { IntersectionObserver } from '../../../../helpers/BrowserHelpers';
import generateKey from '../../utils/generateKey';
import Dropdown from './Dropdown';
import { DATABASE_CHANGE_COLUMN_TYPE, DATABASE_ADD_COLUMN, DATABASE_SORT } from '../../../../types/AnalyticsTypes';

var getSortIcon = function getSortIcon(direction) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return direction === OrderTypes.ASC ? React.createElement(ArrowBottomIcon, props) : React.createElement(ArrowTopIcon, props);
};

var TOOLTIP_BORDER_PADDING = 6;

var ColumnHeaderMore =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ColumnHeaderMore, _React$Component);

  function ColumnHeaderMore() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ColumnHeaderMore);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ColumnHeaderMore)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      showChangeTypeOptions: false,
      showSortOptions: false
    });

    _defineProperty(_assertThisInitialized(_this), "observer", null);

    _defineProperty(_assertThisInitialized(_this), "moreButtonRef", React.createRef());

    _defineProperty(_assertThisInitialized(_this), "disconnectObserver", function () {
      return _this.observer && _this.observer.disconnect();
    });

    _defineProperty(_assertThisInitialized(_this), "onIntersection", function () {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [],
          _ref2 = _slicedToArray(_ref, 1),
          _ref2$ = _ref2[0];

      _ref2$ = _ref2$ === void 0 ? {} : _ref2$;
      var _ref2$$isIntersecting = _ref2$.isIntersecting,
          isIntersecting = _ref2$$isIntersecting === void 0 ? false : _ref2$$isIntersecting;
      return !isIntersecting && _this.setIsControlOpen(false);
    });

    _defineProperty(_assertThisInitialized(_this), "connectObserver", function () {
      if (!_this.moreButtonRef.current) return;
      var database = _this.props.database;
      _this.observer = new IntersectionObserver(_this.onIntersection, {
        root: database.element,
        rootMargin: '0px',
        threshold: 0
      });

      _this.observer.observe(_this.moreButtonRef.current);
    });

    _defineProperty(_assertThisInitialized(_this), "setIsControlOpen", function (open) {
      if (!open) {
        _this.setState({
          showChangeTypeOptions: false,
          showSortOptions: false
        });
      }

      _this.props.setIsControlOpen(open);
    });

    _defineProperty(_assertThisInitialized(_this), "renderColumnControls", function () {
      var _this$props = _this.props,
          database = _this$props.database,
          column = _this$props.column;
      var columnCount = database.getColumnsCount();
      return React.createElement(Menu, {
        onKeyDown: _this.onKeyDown,
        className: "slite-design-system",
        style: {
          width: 220,
          overflow: 'scroll',
          maxHeight: "calc(100vh - ".concat(2 * TOOLTIP_BORDER_PADDING, "px)")
        },
        onRowClick: function onRowClick() {
          _this.setIsControlOpen(false);
        },
        items: [{
          key: 'delete',
          title: 'Delete',
          icon: DeleteIcon,
          action: function action() {
            database.deleteColumn(column.key);
          },
          isAllowed: database.run('canDelete', column.type) && columnCount > 1
        }, {
          key: 'insert-left',
          title: 'Insert left',
          icon: ArrowLeftIcon,
          action: function action() {
            var newKey = generateKey();
            database.insertColumnBefore(column.key, {
              key: newKey
            }).registerScrollColumnKey(newKey).command('track', DATABASE_ADD_COLUMN, {
              source: 'Click insert left'
            });
          },
          isAllowed: database.run('canDelete', column.type)
        }, {
          key: 'insert-right',
          title: 'Insert right',
          icon: ArrowRightIcon,
          action: function action() {
            var newKey = generateKey();
            database.insertColumnAfter(column.key, {
              key: newKey
            }).registerScrollColumnKey(newKey).command('track', DATABASE_ADD_COLUMN, {
              source: 'Click insert right'
            });
          },
          isAllowed: database.run('canDelete', column.type)
        }, {
          key: 'separator-type',
          separation: true,
          isAllowed: database.run('canSort', column.type)
        }, {
          key: 'change-type',
          isAllowed: database.run('canDelete', column.type),
          custom: _this.renderChangeType
        }, {
          key: 'separator-type',
          separation: true,
          isAllowed: database.run('canDelete', column.type)
        }, {
          key: 'sort',
          isAllowed: database.run('canSort', column.type),
          custom: _this.renderSort
        }, {
          key: 'type-options',
          custom: function custom(_ref3) {
            var index = _ref3.index;
            return database.run('renderColumnOptions', {
              key: index,
              column: column
            });
          }
        }]
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderSort", function (_ref4) {
      var index = _ref4.index;
      var _this$props2 = _this.props,
          database = _this$props2.database,
          column = _this$props2.column,
          sort = _this$props2.sort;
      var columnKey = column.key;
      var selectItem = {
        type: OrderTypes.NONE,
        getLabel: function getLabel() {
          return 'Select';
        },
        getIcon: function getIcon() {
          return React.createElement(SwitchIcon, null);
        }
      };
      var clearItem = {
        type: OrderTypes.CLEAR,
        getLabel: function getLabel() {
          return 'Clear sorting';
        },
        getIcon: function getIcon() {
          return React.createElement(CloseIcon, null);
        }
      };
      var sortOptions = database.run('getSortOptions', column.type);
      var items = Object.keys(sortOptions).map(function (direction) {
        return {
          type: direction,
          getLabel: function getLabel() {
            return sortOptions[direction];
          },
          getIcon: function getIcon() {
            return React.createElement("div", {
              className: classNames({
                primary: sort && sort.direction === direction
              })
            }, getSortIcon(direction));
          }
        };
      });
      var currentItem;

      if (sort) {
        items.push(clearItem);
        currentItem = items.find(function (_ref5) {
          var type = _ref5.type;
          return type === sort.direction;
        });
      } else {
        items.unshift(selectItem);
        currentItem = selectItem;
      }

      var onItemClick = function onItemClick(direction) {
        _this.setIsControlOpen(false);

        if ([OrderTypes.NONE, OrderTypes.CLEAR].includes(direction)) {
          return database.removeSort(columnKey);
        }

        database.setSort(columnKey, direction).command('track', DATABASE_SORT);
      };

      var onDropdownClick = function onDropdownClick(event) {
        event.preventDefault();
        event.stopPropagation();

        _this.setState({
          showSortOptions: !_this.state.showSortOptions
        });
      };

      return React.createElement(Dropdown, {
        key: index,
        label: "Sort by",
        items: items,
        currentItem: currentItem,
        open: _this.state.showSortOptions,
        onItemClick: onItemClick,
        onDropdownClick: onDropdownClick
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderConfirmChangeType", function (_ref6) {
      var closeModal = _ref6.closeModal,
          type = _ref6.type;
      return React.createElement("div", {
        className: "padding-largest"
      }, React.createElement("div", {
        className: "font-size-largest bold margin-bottom-large line-height-large"
      }, "Are you sure you want to convert this field type?"), React.createElement("div", {
        className: "shade-10 margin-bottom-large"
      }, "Converting this field type may clear some cell data in this column. You can always convert the field type again later."), React.createElement("div", {
        className: "flexbox flexbox-space-between"
      }, React.createElement(Button.Secondary, {
        onClick: function onClick() {
          return closeModal();
        }
      }, "Cancel"), React.createElement(Button.Primary, {
        onClick: function onClick() {
          _this.onChangeType(type);

          closeModal();
        }
      }, "Convert")));
    });

    _defineProperty(_assertThisInitialized(_this), "onChangeType", function (type) {
      var _this$props3 = _this.props,
          database = _this$props3.database,
          column = _this$props3.column;
      database.command('track', DATABASE_CHANGE_COLUMN_TYPE, {
        from: column.type,
        to: type
      });
      database.changeColumnType(column.key, type);

      _this.setState({
        showChangeTypeOptions: false
      });

      _this.props.setIsControlOpen(false);
    });

    _defineProperty(_assertThisInitialized(_this), "onKeyDown", function (event) {
      if (isHotKey('esc', event)) {
        _this.setIsControlOpen(false);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderChangeType", function (_ref7) {
      var index = _ref7.index;
      var _this$props4 = _this.props,
          database = _this$props4.database,
          column = _this$props4.column;
      var items = [ColumnTypes.TEXT, ColumnTypes.TODO, ColumnTypes.SELECT, ColumnTypes.MULTI_SELECT, ColumnTypes.NUMBER, ColumnTypes.USERS, ColumnTypes.NOTES, ColumnTypes.CREATED_AT, ColumnTypes.CREATED_BY, ColumnTypes.UPDATED_AT, ColumnTypes.UPDATED_BY].map(function (type) {
        return {
          type: type,
          getIcon: function getIcon() {
            return database.run('renderColumnIcon', type);
          },
          getLabel: function getLabel() {
            return database.run('renderColumnType', type);
          }
        };
      });
      var currentItem = {
        type: column.type,
        getIcon: function getIcon() {
          return database.run('renderColumnIcon', column.type);
        },
        getLabel: function getLabel() {
          return database.run('renderColumnType', column.type);
        }
      };

      var onItemClick = function onItemClick(type) {
        database.isColumnEmpty(column.key) ? _this.onChangeType(type) : _this.props.database.openModal({
          meta: {
            size: 500,
            innerComponent: function innerComponent(props) {
              return _this.renderConfirmChangeType(_objectSpread({
                type: type
              }, props));
            }
          }
        });
      };

      var onDropdownClick = function onDropdownClick(event) {
        event.preventDefault();
        event.stopPropagation();

        _this.setState({
          showChangeTypeOptions: !_this.state.showChangeTypeOptions
        });
      };

      return React.createElement(Dropdown, {
        key: index,
        label: "Change column type",
        items: items,
        currentItem: currentItem,
        open: _this.state.showChangeTypeOptions,
        onItemClick: onItemClick,
        onDropdownClick: onDropdownClick
      });
    });

    return _this;
  }

  _createClass(ColumnHeaderMore, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.isControlOpen && !this.props.isControlOpen) {
        this.disconnectObserver();
      }

      if (!prevProps.isControlOpen && this.props.isControlOpen) {
        this.connectObserver();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.disconnectObserver();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props5 = this.props,
          isControlOpen = _this$props5.isControlOpen,
          isHovered = _this$props5.isHovered,
          database = _this$props5.database,
          column = _this$props5.column,
          sort = _this$props5.sort;
      return React.createElement("div", {
        tabIndex: -1,
        onKeyDown: this.onKeyDown,
        "data-qa": "database-column-options",
        style: {
          lineHeight: 0,
          width: 24,
          height: 24,
          outline: 'none'
        },
        className: classNames('flexbox flexbox-no-shrink flexbox-align-center', 'font-size-small font-weight-medium shade-30', {
          'opacity-null': !sort && !isControlOpen && !isHovered
        }),
        ref: this.moreButtonRef
      }, sort && !isHovered && !isControlOpen ? getSortIcon(sort.direction, {
        size: 16,
        className: 'shade-20-on-hover shade-10-on-active primary'
      }) : React.createElement(TinyPopover, {
        isOpen: isControlOpen,
        transitionDuration: 0.25,
        position: "bottom",
        align: "start",
        content: this.renderColumnControls(),
        onPopoverOpening: function onPopoverOpening() {
          return database.blur();
        } //Lets not let the databse catch event meant for the  popover
        ,
        onClickOutside: function onClickOutside() {
          _this2.setIsControlOpen(false);
        } // overrides default `overflow: hidden`, allowing box-shadows to be visible
        ,
        containerStyle: {
          overflow: 'visible',
          zIndex: '3'
        },
        windowBorderPadding: TOOLTIP_BORDER_PADDING
      }, React.createElement(MoreIcon, {
        className: "shade-20-on-hover shade-10-on-active pointer",
        size: 16,
        onClick: function onClick() {
          var isOpen = !isControlOpen;

          _this2.setIsControlOpen(isOpen);

          if (isOpen) {
            database.selectColumn(column.key);
          }
        },
        style: {
          marginTop: -2,
          transform: 'rotate(90deg)'
        }
      })));
    }
  }]);

  return ColumnHeaderMore;
}(React.Component);

_defineProperty(ColumnHeaderMore, "propTypes", {
  database: PropTypes.instanceOf(Database),
  column: PropTypes.object.isRequired,
  isHovered: PropTypes.bool.isRequired,
  isControlOpen: PropTypes.bool.isRequired,
  setIsControlOpen: PropTypes.func.isRequired,
  sort: PropTypes.object
});

export { ColumnHeaderMore as default };